import { render, staticRenderFns } from "./InvoiceDocumentSummary.vue?vue&type=template&id=4f2e65a6&"
import script from "./InvoiceDocumentSummary.vue?vue&type=script&lang=js&"
export * from "./InvoiceDocumentSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports